import { Customer, ICustomer } from './customer.model';

export interface ICustomerViewDto extends ICustomer {
  hasPersonalPricing?: boolean;
  // nombre de transports
  turnover?: number;
  // total paye par le customer
  transports?: number;
  userValidated?: boolean;
}

export class CustomerView extends Customer {
  public hasPersonalPricing?: boolean;
  public turnover?: number;
  public transports?: number;
  public userValidated?: boolean;

  constructor(data: Partial<ICustomerViewDto> = {}) {
    super(data);
    this.hasPersonalPricing = data.hasPersonalPricing;
    this.turnover = data.turnover;
    this.transports = data.transports;
    this.userValidated = data.userValidated;
  }

  override serialize(): Partial<ICustomerViewDto> {
    return {
      ...super.serialize(),
      hasPersonalPricing: this.hasPersonalPricing,
      turnover: this.turnover,
      transports: this.transports,
      userValidated: this.userValidated,
    };
  }
}
